import { render, staticRenderFns } from "./InvoiceServices.vue?vue&type=template&id=331cd572&"
import script from "./InvoiceServices.vue?vue&type=script&lang=ts&"
export * from "./InvoiceServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports